import { Flex, Typography } from 'antd';
import type { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import { usePipelineStepOverview } from '../../hooks/usePipelineStepOverview';
import type { PipelineStepId, PipelineStepState } from '../../types';

const { Text } = Typography;

type PipelineStepOverviewProps = {
  steps: Record<PipelineStepId, PipelineStepState>;
  activeStepIndex: number;
  isSelectDisabled?: boolean;
  onStepSelect: (index: number) => void;
};

export function PipelineStepOverview({
  steps,
  activeStepIndex,
  isSelectDisabled = false,
  onStepSelect,
}: PipelineStepOverviewProps) {
  const { t } = useTranslation('pipelineDebug');
  const items = usePipelineStepOverview(steps, activeStepIndex);

  return (
    <div className="pipeline-debug-steps">
      {items.map((item) => (
        <button
          key={item.stepId}
          type="button"
          className={`pipeline-debug-step-card pipeline-debug-step-card--${item.stepId}${
            item.isActive ? ' pipeline-debug-step-card--active' : ''
          } pipeline-debug-step-card--${item.status}`}
          style={{ '--step-accent': item.accent } as CSSProperties}
          disabled={isSelectDisabled}
          onClick={() => {
            if (isSelectDisabled) {
              return;
            }

            onStepSelect(item.index);
          }}
        >
          <Flex vertical gap={6} align="flex-start" style={{ width: '100%' }}>
            <Flex
              justify="space-between"
              align="center"
              style={{ width: '100%' }}
            >
              <Text strong className="pipeline-debug-step-card-title">
                {t(`steps.${item.stepId}.title`)}
              </Text>
              <span
                className={`pipeline-debug-status-pill pipeline-debug-status-pill--${item.status}`}
              >
                {t(item.statusLabelKey)}
              </span>
            </Flex>
            <Text
              type="secondary"
              className="pipeline-debug-step-card-subtitle"
            >
              {t(`steps.${item.stepId}.subtitle`)}
            </Text>
            <Text className="pipeline-debug-step-card-summary">
              {item.summary}
            </Text>
          </Flex>
        </button>
      ))}
    </div>
  );
}
